import type { Room, RoomDummy } from "@/lib/gql/__generated__/graphql";

export const isRoom = (room: RoomDummy | Room): room is Room => {
	return room.__typename === "Room" || "isDormitoryType" in room;
};

export const isDummyRoom = (room: RoomDummy | Room): room is RoomDummy => {
	return room.__typename === "RoomDummy" || !("isDormitoryType" in room);
};
